import React from 'react';
import { MenuItem, Select, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import './AdjustmentReasonWidget.css';

const OTHER_ADJUSTMENT_REASON_ID = -1;
const AdjustmentReasonWidget = (props) => {
  return (
    <div className="adjustment-reason-widget">
      <div className="row">
        <div className="col-xs-12">
          <div className="subheader2">Reason For Adjustment</div>
          {!!props.adjustmentReasons ? (
            <Select
              fullWidth
              value={props.selectedAdjustmentReason.reasonId}
              onChange={(event) => {
                const reasonId = event.target.value;
                const adjustmentReason = props.adjustmentReasons.find(
                  (adjustmentReason) => reasonId === adjustmentReason.reasonId
                );
                props.handleChangeAdjustmentReason(adjustmentReason);
              }}
            >
              {props.adjustmentReasons.map((adjustmentReason) => (
                <MenuItem
                  key={adjustmentReason.reasonId}
                  value={adjustmentReason.reasonId}
                >
                  {adjustmentReason.reason}
                </MenuItem>
              ))}
            </Select>
          ) : null}
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <TextField
            required={
              props.selectedAdjustmentReason.reasonId ===
              OTHER_ADJUSTMENT_REASON_ID
            }
            multiline
            className="text-area"
            fullWidth
            value={props.selectedAdjustmentReason.reason}
            onChange={(event) => {
              props.handleChangeAdjustmentReason({
                ...props.selectedAdjustmentReason,
                reason: event.target.value
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

AdjustmentReasonWidget.propTypes = {
  selectedAdjustmentReason: PropTypes.object,
  adjustmentReasons: PropTypes.array,
  handleChangeAdjustmentReason: PropTypes.func.isRequired
};

export default AdjustmentReasonWidget;
